<template>
  <div>
    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12" style="margin-top: 25px">
          <field-filled-by :field="field" />
        </el-col>
        
        <el-col :span="6">
            <div class="icon-dropdown-selection">
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus"></i>
              </div>
            </el-button>
          </div>
          </el-col>
      </el-row>

      <el-row type="flex" :gutter="30">
        <el-col :span="8">
          <el-form-item label="Prefix">
            <el-input
              placeholder="Prefix"
              v-model="field.auto_increment_prefix"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item label="Choose your preferences">
            <span class="red-asterisk">*</span>
            <br />
            <el-checkbox-group v-model="field.selected_preferences">
              <div class="checkbox-container">
                <el-checkbox
                  v-for="option in availableOptions"
                  :label="option"
                  :key="option"
                  >{{ option }}</el-checkbox
                >
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="24">
              <el-checkbox v-model="field.properties.allow_to_regenerate"
                >Allow to regenerate</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="30">
            <el-col :span="24">
              <is-field-required :field="field" class="field-required" />
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Length of Characters">
            <el-input-number
              type="number"
              :min="getMinValue()"
              v-model="field.random_text_length"
              placeholder="No of characters"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
//import { mapGetters } from "vuex";
export default {
  name: "templates-formComponents-SingleLineText",
  components: {
    TitleAndDescription: () => import("./TitleAndDescription"),
    IsFieldRequired: () => import("./IsFieldRequired"),
    FieldFilledBy: () => import("./FieldFilledBy"),
    Placeholder: () => import("./Placeholder"),
  },

  props: ["field", "fieldsData"],
  computed: {
    //...mapGetters("globalVariables", ["getAllGlobalVariables"]),
    // allGlobalVariables() {
    //   return this.getAllGlobalVariables
    //     ? this.getAllGlobalVariables.data || []
    //     : [];
    // },
  },
  mounted() {
    console.log("random text", this.field);
    // this.fetchGlobalVaribales();
    if (this.field && this.field.icon_name) {
      this.templateIconPath = this.field.icon_name;
    }
  },
  data() {
    return {
      checkAll: false,
      availableOptions: [
        "Use Letters",
        "Use non capitalized",
        "Use Numbers",
        "Use Special Characters",
      ],
      iconPickerdialogVisible: false,
      templateIconPath:'',
    };
  },
  methods: {
    // async fetchGlobalVaribales() {
    //   let params = {
    //     get_all: true,
    //     input_type: this.field.input_type,
    //   };

    //   await this.$store.dispatch(
    //     "globalVariables/fetchGlobalVariables",
    //     params
    //   );
    // },
    // setGlobalVariable() {
    //   let globalVariable = this.allGlobalVariables.find(
    //     (x) => x._id == this.field.global_variable_id
    //   );
    //   this.field.label = globalVariable.label;
    //   this.field.description = globalVariable.description;
    //   this.field.options = globalVariable.options;
    // },
    closeSelectIcon() {
      this.iconPickerdialogVisible = false;
    },
    getIconPath(icon) {
      this.templateIconPath = icon;
      this.$set(this.field, 'icon_name', icon);
      this.iconPickerdialogVisible = false;
    },
    getMinValue() {
      let min = 5;
      switch (this.field.selected_preferences.length) {
        case 1:
          min = 8;
          break;
        case 2:
          min = 6;
          break;
      }
      this.field.random_text_length = min;
      return min;
    },
  },
};
</script>

<style lang="scss">
.checkbox-container {
  display: flex;
  flex-direction: column;
}

.el-checkbox {
  align-items: center;
}
</style>
